import { render, staticRenderFns } from "./InputPro.vue?vue&type=template&id=5c21560a&scoped=true&"
import script from "./InputPro.vue?vue&type=script&lang=js&"
export * from "./InputPro.vue?vue&type=script&lang=js&"
import style0 from "./InputPro.vue?vue&type=style&index=0&id=5c21560a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c21560a",
  null
  
)

export default component.exports